import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";

export function useOrganizationHierarchyForLoggedInUser() {
    return useQuery(["organization-hierarchy-for-user"],
        () => new Client().organization_GetOrganizationHierarchyForLoggedInUser(),
        {staleTime: Infinity});
}
